import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw-flex tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden" }
const _hoisted_2 = { class: "tw-grow tw-px-5 tw-pb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "tw-font-medium" }, "Video in use", -1)
const _hoisted_4 = { class: "tw-mt-1.5 tw-w-full tw-text-sm tw-leading-tight tw-text-slate-600" }
const _hoisted_5 = { class: "tw-mt-5 tw-max-h-[300px] tw-overflow-y-auto tw-pr-2" }
const _hoisted_6 = { class: "tw-text-sm tw-font-medium tw-text-black" }
const _hoisted_7 = { class: "tw-mt-0.5 tw-text-xs tw-text-slate-600" }
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-items-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-font-medium tw-text-black" }, "Visit", -1)
const _hoisted_11 = {
  key: 0,
  className: "tw-mt-1 tw-text-xs tw-text-slate-600"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { VideoAssetUsage } from '@goldcast/api/backend';
import { IconArrowUpRight } from '@tabler/icons-vue';
import moment from 'moment';

import { redirectToUsage, transformVideoAssetUsageEntityType } from '../utils';

import StudioDialog from '@/studioComponents/StudioDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryUsageDialog',
  props: {
    usageData: {}
  },
  setup(__props: any) {



const formatDate = (date: string) => moment(date).format('MMM D, YYYY');

const onUsageClick = (usage: VideoAssetUsage): void => {
  redirectToUsage(usage);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioDialog, {
    primaryActionTitle: "Close",
    onPrimaryAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" This video is currently in use in the following destinations and cannot be removed. Please remove the video from these destinations first to proceed. "),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageData, (usage) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: usage?.entity_id,
                  class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-py-3"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(usage.entity_title), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(usage.entity_subtype || _unref(transformVideoAssetUsageEntityType)(usage)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "tw-flex tw-cursor-pointer tw-items-center tw-space-x-1 tw-text-sm hover:tw-underline",
                      onClick: ($event: any) => (onUsageClick(usage))
                    }, [
                      _hoisted_10,
                      _createVNode(_unref(IconArrowUpRight), { class: "tw-h-4 tw-w-4 tw-text-black" })
                    ], 8, _hoisted_9),
                    (usage.entity_created_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (usage.entity_type === 'EVENT')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Event Date: "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, "Created: ")),
                          _createTextVNode(" " + _toDisplayString(formatDate(usage.entity_created_date)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})